export const STORAGE_KEY = {
  TOKEN: 'accessToken',
  TMP_TOKEN: 'tmpAccessToken',
  TASK_ID: 'taskId',
  SETTINGS: 'settings',
  USERINFO: 'userInfo',
  WALLET_ACCOUNT: 'walletAccount',
  TASK_RULE_PARAMS: 'taskRuleParams',
};
